import 'datatables.net-bs5';
import DataTable, {AjaxData} from "datatables.net";
import {get, init_choices, notifier, on, post, select_choices, slideDown, slideUp, val} from "../util";
import {gold, nwdb_link} from "./util";
import {Order} from "datatables.net-bs5";

declare let crafting_id : number;
declare const crafting : {
    items_id : number,
    amount: number,
    stations_id: number,
    tax: number,
    extra: number,
    materials: {
        items: {
            nw_items_id: number,
            extra: number
        }[],
        amount: number
    }[]
};

interface CraftingAjaxData extends AjaxData {
    station_id : number
}

export default class {
    static init = () => {
        list();
        edit();
        edit_old();
    }
}



function list() {
    let table = document.querySelector('.datatable[data-table="nw_crafting"]') as HTMLElement;
    if(!table) {
        return;
    }

    let datatable = new DataTable('.datatable[data-table="nw_crafting"]',{
        pageLength: 20,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getCrafting',
            data: function(data : CraftingAjaxData) {
                let station = document.querySelector('[name="nw_stations_id"]') as HTMLInputElement;
                if(station.value) {
                    data.station_id = parseInt(station.value);
                }
                return data;
            }
        },
        columns: [
            { data: null, render: function (data, type, row) {
                    return `<a href="/nw/crafting/${row.id}" class="text-decoration-none"><img src="https://cdn.nwdb.info/db/images/live/v50/icons/items/resource/${data.nw_id}.png" class="img-fluid" style="width:20px" /> ${row.name}</a> ` + nwdb_link(data.nw_id);
                }},
            { data: 'station' },
            { data: null, render: function (data, type, row) {
                    return gold(data.cost);
                }},
            { data: null, render: function (data, type, row) {
                    return gold(data.sell);
                }},
            { data: null, render: function (data, type, row) {
                    return gold(data.profit,data.profit_raw_color);
                }},
            { data: null, render: function (data, type, row) {
                    return gold(data.profit_percent,data.profit_percent_raw_color);
                }},
            { data: null, render: function (data, type, row) {
                    return gold(data.sell_no_extra);
                }},
            { data: null, render: function (data, type, row) {
                    return gold(data.profit_no_extra,data.profit_no_extra_raw_color);
                }},
            { data: null, render: function (data, type, row) {
                    return gold(data.profit_percent_no_extra,data.profit_percent_no_extra_raw_color);
                }}
        ],
        order: [[5,"desc"]] as Order[]
    });

    on('change','[name="nw_stations_id"]',(target : HTMLInputElement) => {
        datatable.ajax.reload();
    });
}

function edit_old() {
    on('change','.js-crafts',(target : HTMLInputElement) => {
        let id = parseInt(target.value ?? "0");
        if(isNaN(id)) {
            id = 0;
        }
        window.location.href = '/nw/crafting/' + id;
    });

    on('change','.js-groups_id',(target : HTMLSelectElement) => {
        let id = parseInt(target.value ?? "0");
        if(isNaN(id)) {
            id = 0;
        }
        if(id > 0) {
            get('?do=getGroupItems', {nw_groups_id: id},(data : any) => {
                if(data) {
                    let materials = target.closest('.row')?.querySelector('.js-materials') as HTMLSelectElement;
                    select_choices(materials, data);
                    select_choices(target,"");
                }
            });
        }
    });
}

function edit() {
    if(typeof crafting_id == 'undefined') {
        return;
    }

    on('click','.js-add-pools',(target : HTMLButtonElement) => {
        let row = (document.querySelector('.row-pools-template') as HTMLDivElement).cloneNode(true) as HTMLDivElement;
        row.classList.remove('row-pools-template', 'd-none');
        row.querySelector('.row-pools-materials-template')?.classList.remove('row-pools-materials-template', 'd-none');
        row.querySelector('.js-choices')?.classList.remove('choices__input');

        let wrapper = document.querySelector('.js-pools-wrapper') as HTMLDivElement;
        wrapper.appendChild(row);

        slideDown(row, 500, () => {
            init_choices();
        });
    },true);

    on('click','.js-remove-pools',(target : HTMLButtonElement) => {
        let row = target.closest('.row-pools') as HTMLDivElement;
        slideUp(row, 500, () => {
            row.remove();
        });
    },true);

    on('click','.js-add-pools-materials',(target : HTMLButtonElement) => {
        let row = (document.querySelector('.row-pools-materials-template') as HTMLDivElement).cloneNode(true) as HTMLDivElement;
        row.classList.remove('row-pools-materials-template', 'd-none');
        row.querySelector('.js-choices')?.classList.remove('choices__input');
        row.querySelectorAll('label').forEach((label) => {
            label.remove();
        });

        let wrapper = target.parentElement?.parentElement?.previousElementSibling as HTMLDivElement;
        wrapper.appendChild(row);

        slideDown(row, 200, () => {
            init_choices();
        });
    },true);

    on('click','.js-remove-pools-materials',(target : HTMLButtonElement) => {
        let row = target.closest('.row-pools-materials') as HTMLDivElement;
        slideUp(row, 200, () => {
            row.remove();
        });
    },true);

    on('change','.js-items_id,.js-stations_id', save_crafting);
    on('input','.js-pools-amount', (element : HTMLElement) => save_pool(element), true);
    on('change','.js-pools-materials-items_id', (element : HTMLElement) => save_material(element), true);
    on('input','.js-pools-materials-extra', (element : HTMLElement) => save_material(element), true);
}

function save_crafting() {
    post('?do=saveCrafting', {
        crafting_id: crafting_id,
        items_id: val('.js-items_id'),
        amount: val('.js-amount'),
        stations_id: val('.js-stations_id'),
        tax: val('.js-tax'),
        extra: val('.js-extra')
    },(data : any) => {
        if(data.status == 1) {
            crafting_id = data.crafting_id;
            notifier.success(data.message);
        } else {
            notifier.error(data.message);
        }
    });
}

function save_pool(element : HTMLElement) {
    let row = element.closest('.row-pools') as HTMLDivElement;
    let id = parseInt(row.dataset.pools_id ?? "0");
    post('?do=savePool', {
        crafting_id: crafting_id,
        pools_id: id,
        amount: (row.querySelector('.js-pools-amount') as HTMLInputElement).value
    },(data : any) => {
        if(data.status == 1) {
            notifier.success(data.message);
        } else {
            notifier.error(data.message);
        }
    });
}

function save_material(element : HTMLElement) {
    let row = element.closest('.row-pools-materials') as HTMLDivElement;
    let pools = row.closest('.row-pools') as HTMLDivElement;
    let id = parseInt(row.dataset.materials_id ?? "0");
    let pools_id = parseInt(pools.dataset.pools_id ?? "0");
    post('?do=saveMaterial', {
        crafting_id: crafting_id,
        pools_id: pools_id,
        materials_id: id,
        items_id: (row.querySelector('.js-pools-materials-items_id') as HTMLInputElement)?.value,
        extra: (row.querySelector('.js-pools-materials-extra') as HTMLInputElement)?.value
    },(data : any) => {
        if(data.status == 1) {
            notifier.success(data.message);
        } else {
            notifier.error(data.message);
        }
    });
}
